var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
  let {realTip } = options; 
__p+='\n  ';
 if(options.realTip && options.realTip.length && options.realTip.indexOf("solar system") === -1) { 
__p+='\n    <div class="ldp-real-tip-section">\n      <div class="ldp-real-tip">\n        <div class=\'ldp-insight-img\'></div>  \n      </div>\n      <div class="ldp-real-tip">\n        <span>'+
((__t=( realTip ))==null?'':__t)+
'<span>\n        <span class="hide color-gray js-thumb-display feedback-text"> Did you find this useful?\n          <i class="ra ra-thumb-up thumb" data-omtag="ldp:property-details:insight-thumbs:up"></i>\n          <i class="ra ra-thumb-down thumb" data-omtag="ldp:property-details:insight-thumbs:down"></i>\n        </span>\n        <span class="hide color-gray js-feedback-display feedback-text"> Thanks for your feedback. </span>\n      </div>\n    </div>\n  ';
 } 
__p+='';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/realtip_section.jst.ejs